import React from "react";
import {styled, theme} from "@reside/ui";

export const PermissionPendingSuffix = () => (
  <PendingSuffix>(Pending)</PendingSuffix>
);

export const PermissionStatusGroup = styled.div`
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: flex-end;
  white-space: nowrap;
`;

const PendingSuffix = styled.span`
  color: ${theme.color.gray100};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-left: 6px;
`;
